import gql from 'graphql-tag';

const returnsFragment = gql`
    fragment Returns on PerformanceDetail {
        oneYearReturn
        threeYearReturn
        fiveYearReturn
        tenYearReturn
        sinceInceptionReturn
    }
`;

export const AVERAGE_ANNUAL_TOTAL_RETURNS = gql`
    query AverageAnnualTotalReturns($ticker: String!) {
        mutualFund(ticker: $ticker) {
            name: shortName
            inceptionDate
            tackedReturnFundInceptionDate
            standardPerformanceReturns {
                quarterlyAnnualReturns {
                    fundPerformance {
                        asOfDate
                        oneYearReturn
                        threeYearReturn
                        fiveYearReturn
                        tenYearReturn
                        sinceInceptionReturn
                        oneYearReturnTacked
                        threeYearReturnTacked
                        fiveYearReturnTacked
                        tenYearReturnTacked
                        sinceInceptionReturnTacked
                    }
                }
            }
            benchmarkPerformanceDetail {
                benchmarkCode
                benchmarkName
                primaryBenchmarkName
                primaryBenchmarkCode
                benchMarkPerformance {
                    ...Returns
                }
                primaryBenchMarkPerformance {
                    ...Returns
                }
                fundPerformance {
                    ...Returns
                }
            }
        }
    }
    ${returnsFragment}
`;
